import { RefBool } from '@tblabs/truffle';
import { Icon } from '../General/Icon';


export class SelectIcon extends Icon
{
    constructor(isSelectedByUser: RefBool)
    {
        super(isSelectedByUser.value ? "check_box" : "check_box_outline_blank", "yellow");
        this.Class("select-button");

        if (isSelectedByUser.value)
        {
            this.Opacity(1);
        }

        this.OnClick(() =>
        {
            isSelectedByUser.Toggle();

            this.Text(isSelectedByUser.value ? "check_box" : "check_box_outline_blank");

            if (isSelectedByUser.value)
            {
                this.Opacity(1);
            }
        });
    }
}
